import React, { FC } from 'react';
import { FlexGrid } from '../../../../components/FlexGrid';
import { gray } from '../../../../components/Color';
import { Typography } from '../../../../components/Typography';
import { useTranslationAPI } from '../../../translations';
import { CloakLoading } from '../../../../components/CloakLoading';
import { EnvelopeO } from '../../../../components/Icons/EnvelopeO';
import { publicJobModuleCodes } from '../../../../data/translations/publicJobModuleCodes';

export const PublicJobSubscriptionTitle: FC<React.PropsWithChildren<{ isLoading?: boolean }>> = ({ isLoading }) => {
	const { translate } = useTranslationAPI();

	return (
		<FlexGrid
			gap='scanty'
			center
		>
			{isLoading && (
				<CloakLoading
					noBackground
					inline
					size='small'
				/>
			)}
			{!isLoading && (
				<EnvelopeO
					width='24px'
					height='19px'
					fill={gray[6]}
				/>
			)}
			<Typography bold>{translate(publicJobModuleCodes.subscriptionTitle)}</Typography>
		</FlexGrid>
	);
};
